import { render, staticRenderFns } from "./StudentCourseDetail.vue?vue&type=template&id=6dd0b758&scoped=true"
import script from "./StudentCourseDetail.vue?vue&type=script&lang=js"
export * from "./StudentCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentCourseDetail.vue?vue&type=style&index=0&id=6dd0b758&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0b758",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd0b758')) {
      api.createRecord('6dd0b758', component.options)
    } else {
      api.reload('6dd0b758', component.options)
    }
    module.hot.accept("./StudentCourseDetail.vue?vue&type=template&id=6dd0b758&scoped=true", function () {
      api.rerender('6dd0b758', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/StudentCourseDetail.vue"
export default component.exports